

module.exports = {
	loginURL: 'https://accountws-sb-02.qa.afreespace.com/api/login/code?requiredRefreshToken=true',
    loginURLUS: 'https://accountws.us.afreespace.com/api/login/code?requiredRefreshToken=true',

    refreshTokenURL: 'https://accountws-sb-02.qa.afreespace.com/api/refresh-token?requiredRefreshToken=true',
    refreshTokenURLUS: 'https://accountws.us.afreespace.com/api/refresh-token?requiredRefreshToken=true',

    ADMINURL: 'https://admin-temp.afreespace.com/',

    tim: process.env.tim || 'https://analytics.dev.afreespace.com/apiv2/report/tim-health',
    timus: 'https://analytics.us.afreespace.com/apiv2/report/tim-health',

    timp: "https://analytics.dev.afreespace.com/apiv2/report/tim_p-health",
    timpus: "https://analytics.us.afreespace.com/apiv2/report/tim_p-health",

    flo: "https://analytics.dev.afreespace.com/apiv2/report/flo-health",
    flous: "https://analytics.us.afreespace.com/apiv2/report/flo-health",

    batTim: "https://analytics.dev.afreespace.com/apiv2/report/bat_tim-health",
    batTimus: "https://analytics.us.afreespace.com/apiv2/report/bat_tim-health",

    pamc: "https://analytics.dev.afreespace.com/apiv2/report/pam_c-health",
    pamcus: "https://analytics.us.afreespace.com/apiv2/report/pam_c-health",

    pal: "https://analytics.dev.afreespace.com/apiv2/report/pal-health",
    palus: "https://analytics.us.afreespace.com/apiv2/report/pal-health",

	batFlo: "https://analytics.dev.afreespace.com/apiv2/report/bat_flo-health",
	batFlous: "https://analytics.us.afreespace.com/apiv2/report/bat_flo-health",
	
	base: "https://5xex5fmp64.execute-api.eu-west-1.amazonaws.com/qa",

	mediaServerUrl: "https://prodws.afreespace.com/api/admin/media-server",
    mediaServerUrlus: "https://accountws.us.afreespace.com/api/admin/media-server",
    mediaServerCertificateUrl: "https://data.afreespace.com/admin/new-certs-pending",
    mediaServerCertificateUrlus: "https://signage.us.afreespace.com/admin/new-certs-pending",
    mediaServerStatusUrl: "https://data.afreespace.com/admin/player/status",
    mediaServerStatusUrlus: "https://signage.us.afreespace.com/admin/player/status"

}

//before moving to prod, change all dev urls to prod
